import { AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
    openDropdown: 'cidhum' | 'research' | null = null;
    isSolidNavbar = false;
    isPastHero = false;
    private heroObserver?: IntersectionObserver;
    private routerSub?: Subscription;

    constructor(
        private viewportScroller: ViewportScroller,
        private router: Router,
        private zone: NgZone
    ) {}

    // Navbar Sticky
    isSticky: boolean = false;
    @HostListener('window:scroll')
    checkScroll() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    private isHomePage(): boolean {
        const url = this.router.url.split('#')[0].split('?')[0];
        return url === '/' || url === '';
    }

    public onClick(elementId: string): void {
        if (this.isHomePage()) {
            this.viewportScroller.scrollToAnchor(elementId);
        } else {
            this.router.navigate(['/'], { fragment: elementId });
            this.router.events.pipe(
                filter(e => e instanceof NavigationEnd),
                take(1)
            ).subscribe(() => {
                setTimeout(() => {
                    this.viewportScroller.scrollToAnchor(elementId);
                }, 100);
            });
        }
    }

    ngOnInit() {
        this.checkScroll();
        this.updateNavbarAppearance();
        this.routerSub = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.updateNavbarAppearance();
            this.observeHero();
        });
    }

    ngAfterViewInit(): void {
        this.observeHero();
    }

    ngOnDestroy(): void {
        this.heroObserver?.disconnect();
        this.routerSub?.unsubscribe();
    }

    private updateNavbarAppearance(): void {
        this.isSolidNavbar = !this.isHomePage();
    }

    private observeHero(): void {
        this.heroObserver?.disconnect();
        this.heroObserver = undefined;

        if (!this.isHomePage()) {
            this.isPastHero = true;
            return;
        }

        const hero = document.getElementById('home');
        if (!hero) {
            this.isPastHero = false;
            return;
        }

        this.heroObserver = new IntersectionObserver(([entry]) => {
            this.zone.run(() => {
                this.isPastHero = !entry.isIntersecting;
            });
        }, { threshold: 0, rootMargin: '-50px 0px 0px' });
        this.heroObserver.observe(hero);
    }

    toggleDropdown(menu: 'cidhum' | 'research'): void {
        this.openDropdown = this.openDropdown === menu ? null : menu;
    }

    closeDropdown(): void {
        this.openDropdown = null;
    }

    navigateTo(elementId: string, closeMobile = false): void {
        this.closeDropdown();
        if (closeMobile) {
            this.classApplied = false;
        }
        this.onClick(elementId);
    }

    closeMobileNavigation(): void {
        this.openDropdown = null;
        this.classApplied = false;
    }

    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied;
        if (!this.classApplied) {
            this.openDropdown = null;
        }
    }

}
